// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Footer_toolbar__6Kfj0","text":"Footer_text__BdXqz"};